export const VISIT_PATIENT_SUMMARY_REQUEST = 'VISIT_PATIENT_SUMMARY_REQUEST'
export const VISIT_PATIENT_SUMMARY_SUCCESS = 'VISIT_PATIENT_SUMMARY_SUCCESS'
export const VISIT_PATIENT_SUMMARY_FAIL = 'VISIT_PATIENT_SUMMARY_FAIL'

export const VISIT_PATIENT_GET_LIST_REQUEST = 'VISIT_PATIENT_GET_LIST_REQUEST'
export const VISIT_PATIENT_GET_LIST_SUCCESS = 'VISIT_PATIENT_GET_LIST_SUCCESS'
export const VISIT_PATIENT_GET_LIST_FAIL = 'VISIT_PATIENT_GET_LIST_FAIL'

export const CUSTOMER_SATISFACTION_SUMMARY_REQUEST =
  'CUSTOMER_SATISFACTION_SUMMARY_REQUEST'
export const CUSTOMER_SATISFACTION_SUMMARY_SUCCESS =
  'CUSTOMER_SATISFACTION_SUMMARY_SUCCESS'
export const CUSTOMER_SATISFACTION_SUMMARY_FAIL =
  'CUSTOMER_SATISFACTION_SUMMARY_FAIL'

export const CUSTOMER_SATISFACTION_TABLE_REQUEST =
  'CUSTOMER_SATISFACTION_TABLE_REQUEST'
export const CUSTOMER_SATISFACTION_TABLE_SUCCESS =
  'CUSTOMER_SATISFACTION_TABLE_SUCCESS'
export const CUSTOMER_SATISFACTION_TABLE_FAIL =
  'CUSTOMER_SATISFACTION_TABLE_FAIL'

export const CUSTOMER_SATISFACTION_EXPORT_REQUEST =
  'CUSTOMER_SATISFACTION_EXPORT_REQUEST'
export const CUSTOMER_SATISFACTION_EXPORT_SUCCESS =
  'CUSTOMER_SATISFACTION_EXPORT_SUCCESS'
export const CUSTOMER_SATISFACTION_EXPORT_FAIL =
  'CUSTOMER_SATISFACTION_EXPORT_FAIL'

export const CUSTOMER_SATISFACTION_CHART_REQUEST =
  'CUSTOMER_SATISFACTION_CHART_REQUEST'
export const CUSTOMER_SATISFACTION_CHART_SUCCESS =
  'CUSTOMER_SATISFACTION_CHART_SUCCESS'
export const CUSTOMER_SATISFACTION_CHART_FAIL =
  'CUSTOMER_SATISFACTION_CHART_FAIL'

export const CUSTOMER_SATISFACTION_RESET = 'CUSTOMER_SATISFACTION_RESET'

export const TRANSACTION_CUSTOMER_LIST_REQUEST = 'TRANSACTION_CUSTOMER_LIST_REQUEST'
export const TRANSACTION_CUSTOMER_LIST_SUCCESS = 'TRANSACTION_CUSTOMER_LIST_SUCCESS'
export const TRANSACTION_CUSTOMER_LIST_FAIL = 'TRANSACTION_CUSTOMER_LIST_FAIL'

export const TRANSACTION_CUSTOMER_SUMMARY_REQUEST = 'TRANSACTION_CUSTOMER_SUMMARY_REQUEST'
export const TRANSACTION_CUSTOMER_SUMMARY_SUCCESS = 'TRANSACTION_CUSTOMER_SUMMARY_SUCCESS'
export const TRANSACTION_CUSTOMER_SUMMARY_FAIL = 'TRANSACTION_CUSTOMER_SUMMARY_FAIL'

export const TRANSACTION_CUSTOMER_EXPORT_REQUEST = 'TRANSACTION_CUSTOMER_EXPORT_REQUEST'
export const TRANSACTION_CUSTOMER_EXPORT_SUCCESS = 'TRANSACTION_CUSTOMER_EXPORT_SUCCESS'
export const TRANSACTION_CUSTOMER_EXPORT_FAIL = 'TRANSACTION_CUSTOMER_EXPORT_FAIL'

export const PATIENT_VISIT_OVERVIEW_REQUEST = 'PATIENT_VISIT_OVERVIEW_REQUEST'
export const PATIENT_VISIT_OVERVIEW_SUCCESS = 'PATIENT_VISIT_OVERVIEW_SUCCESS'
export const PATIENT_VISIT_OVERVIEW_FAIL = 'PATIENT_VISIT_OVERVIEW_FAIL'

export const PATIENT_VISIT_PEAK_HOURS_REQUEST =
  'PATIENT_VISIT_PEAK_HOURS_REQUEST'
export const PATIENT_VISIT_PEAK_HOURS_SUCCESS =
  'PATIENT_VISIT_PEAK_HOURS_SUCCESS'
export const PATIENT_VISIT_PEAK_HOURS_FAIL =
  'PATIENT_VISIT_PEAK_HOURS_FAIL'
export const PATIENT_VISIT_PEAK_HOURS_RESET =
  'PATIENT_VISIT_PEAK_HOURS_RESET'

export const PATIENT_VISIT_OVERVIEW_EXPORT_REQUEST =
  'PATIENT_VISIT_OVERVIEW_EXPORT_REQUEST'
export const PATIENT_VISIT_OVERVIEW_EXPORT_SUCCESS =
  'PATIENT_VISIT_OVERVIEW_EXPORT_SUCCESS'
export const PATIENT_VISIT_OVERVIEW_EXPORT_FAIL =
  'PATIENT_VISIT_OVERVIEW_EXPORT_FAIL'

export const PATIENT_VISIT_OVERVIEW_RESET = 'PATIENT_VISIT_OVERVIEW_RESET'

export const MARKETING_REVENUE_REQUEST = 'MARKETING_REVENUE_REQUEST'
export const MARKETING_REVENUE_SUCCESS = 'MARKETING_REVENUE_SUCCESS'
export const MARKETING_REVENUE_FAIL = 'MARKETING_REVENUE_FAIL'

export const MARKETING_REVENUE_EXPORT_REQUEST =
  'MARKETING_REVENUE_EXPORT_REQUEST'
export const MARKETING_REVENUE_EXPORT_SUCCESS =
  'MARKETING_REVENUE_EXPORT_SUCCESS'
export const MARKETING_REVENUE_EXPORT_FAIL = 'MARKETING_REVENUE_EXPORT_FAIL'

export const MARKETING_REVENUE_RESET = 'MARKETING_REVENUE_RESET'
